export default {
  properties: {
    year: {
      calc: {
        func: '$methods.moment().format("YYYY")',
        when: '!this.year'
      },
      fieldRequired: true,
      title: 'Wybierz rok',
      type: 'number'
    },

    month: {
      calc: {
        func: '$methods.moment().format("MM") - 1',
        when: '!this.month && this.month !== 0'
      },
      fieldRequired: true,
      title: 'Wybierz miesiąc',
      type: 'number'
    },

    firstName: {
      fieldRequired: true,
      title: 'Imię',
      type: 'string'
    },

    lastName: {
      fieldRequired: true,
      title: 'Nazwisko',
      type: 'string'
    },

    fullName: {
      calc: {
        func: '(this.firstName + " " + this.lastName).trim()',
        when: 'this.firstName && this.lastName'
      },
      fieldRequired: true,
      type: 'string'
    },

    phoneNumber: {
      fieldRequired: true,
      title: 'Numer telefonu',
      type: 'string'
    },

    email: {
      fieldRequired: true,
      format: 'email',
      title: 'Adres e-mail',
      type: 'string'
    }
  },
  title: 'Wniosek KO',
  type: 'object'
};
